var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.pageData.length > 0,
          expression: "pageData.length > 0"
        }
      ]
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "chart-box" }, [
        _c("div", {
          style: "height:" + _vm.chartHeight + "px",
          attrs: { id: "tableChart" }
        })
      ]),
      _vm._v(" "),
      _c("goldDetailDialog", {
        ref: "goldDetailDialog",
        attrs: { id: _vm.goldDetailDialogId, isFnc: _vm.isFnc },
        on: {
          "update:id": function($event) {
            _vm.goldDetailDialogId = $event
          },
          "update:isFnc": function($event) {
            _vm.isFnc = $event
          },
          "update:is-fnc": function($event) {
            _vm.isFnc = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", { staticClass: "common-title" }, [_vm._v("追溯记录")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a018e664", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a018e664","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gold-page/gold-detail-flow-detail.vue
// module id = X02X
// module chunks = 1